import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useState } from 'react';
import { useLoader } from '../../../../../helpers/useLoader';
import { ToolDeleteStrategy } from '../../../projectDetails.models';
import { QuestionDelete } from '../components/QuestionDelete';
import { IProjectDetailsToolsBl } from '../projectDetailsTools.bl';
import { IQuestion } from '../projectDetailsTools.models';

interface IProps {
  question: IQuestion;
  isAttribute: boolean;
}

export const QuestionDeleteContainer = observer((props: IProps): ReactElement => {
  const projectDetailsToolsBl = useInjection(IProjectDetailsToolsBl.$);

  const { isLoading, withLoaderAsync } = useLoader();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [strategy, setStrategy] = useState<ToolDeleteStrategy>(ToolDeleteStrategy.None);
  const [showDiscardConfirmModal, setShowDiscardConfirmModal] = useState<boolean>(false);

  const handleDeleteConfirmedAsync = async (): Promise<void> => {
    if (strategy === ToolDeleteStrategy.Discard) {
      await withLoaderAsync(async () => {
        await projectDetailsToolsBl.getQuestionAffectAsync(props.question.id);
        setShowDiscardConfirmModal(true);
      }, 'tool-delete-confirm-button');
    } else {
      await handleDeleteQuestionAsync();
    }
  };

  const handleDeleteQuestionAsync = async (): Promise<void> => {
    await withLoaderAsync(async () => {
      await projectDetailsToolsBl.deleteQuestionAsync(props.question.id, strategy);
      setShowDiscardConfirmModal(false);
    }, 'tool-delete-confirm-button');
  };

  const handleCancelAsync = (): void => {
    if (!isLoading) {
      setShowModal(false);
    }
  };

  const handleDeleteAsync = async (): Promise<void> => {
    await withLoaderAsync(async () => {
      await projectDetailsToolsBl.getQuestionUsageAsync(props.question.id);
      setShowModal(true);
    });
  };

  const handleStrategyChangeAsync = (strategy: ToolDeleteStrategy): void => {
    setStrategy(strategy);
  };

  const handleCancelDiscardAsync = (): void => {
    if (!isLoading) {
      setShowDiscardConfirmModal(false);
    }
  };

  const toolUsage = projectDetailsToolsBl.store.toolsUsage;
  const isAttribute = props.isAttribute;
  const toolAffect = projectDetailsToolsBl.store.toolAffect;

  return (
    <QuestionDelete
      isAttribute={isAttribute}
      isLoading={isLoading}
      showModal={showModal}
      showDiscardConfirmModal={showDiscardConfirmModal}
      strategy={strategy}
      toolUsage={toolUsage}
      onCancel={handleCancelAsync}
      onCancelDiscard={handleCancelDiscardAsync}
      onDelete={handleDeleteAsync}
      onConfirmDiscard={handleDeleteQuestionAsync}
      onDeleteConfirmed={handleDeleteConfirmedAsync}
      onStrategyChange={handleStrategyChangeAsync}
      toolAffect={toolAffect}
    />
  );
});
